import CityPage from "@/components/feature/CityPage";

const data = {
  cityName: "Shakopee",
  stateName: "Minnesota",
  stateAbbr: "MN",
  stateRoute: "/minnesota",
  heroImageQuery:
    "Aerial view of Shakopee Minnesota cityscape with downtown along Highway 169, Canterbury Park horse racing track, Valleyfair amusement park visible, Minnesota River valley, suburban residential neighborhoods with parks, southwest metro area, warm golden hour lighting, professional cityscape photography, no readable text or signs",
  heroImageSeq: "shakopee-mn-hero-2026",
  heroDescription:
    "Business trip to Europe in two weeks? Family vacation to Mexico and your passport just expired? Valleyfair season trip to Canada? Need a first-time passport for a new job? We help Shakopee residents — from Canterbury Park and Valleyfair families to southwest metro professionals and Prior Lake commuters — get their passports fast. As a registered U.S. Department of State courier — not a reseller — we offer a best price guarantee and rates typically 30–100% lower than FedEx, Staples, and other third-party passport courier resellers. As fast as 24 hours. A+ BBB rated.",
  geoPosition: "44.7974; -93.5272",
  geoPlacename: "Shakopee, Minnesota",
  geoRegion: "US-MN",
  canonicalUrl: "https://fastpassportcenter.com/shakopee/",
  localAreaTitle: "Serving Shakopee & Southwest Metro Scott County",
  localAreaText: [
    "Shakopee, Minnesota is a dynamic southwest metro suburb with a distinctive character that blends historic small-town charm with modern suburban energy. Located along the Minnesota River, the city has grown into a major destination in the Twin Cities metro area, driven by attractions like Canterbury Park, Valleyfair amusement park, and the Mystic Lake Casino nearby. These attractions draw visitors from across the region and create a community where travel is part of the culture.",
    "The city's downtown along Highway 169 and the historic district near the river has seen significant revitalization, attracting restaurants, shops, and new residents. Shakopee's business community is growing, with companies in technology, manufacturing, and healthcare establishing operations in the city. These professionals often travel for conferences, client meetings, and business development.",
    "Shakopee's location in Scott County places it at the intersection of the southwest metro and the exurban communities along the Minnesota River. The city's proximity to Prior Lake, Chaska, and Eden Prairie creates a regional community where residents travel together for group trips, sports tournaments, and family vacations. The area's strong school system and youth sports programs also generate travel for competitions and tournaments.",
    "The residential neighborhoods of Shakopee are diverse, from historic homes near the river to newer developments in the city's north and east. Families in these communities are active travelers — spring break trips, summer vacations, and visits to relatives abroad are all common. The area's proximity to MSP Airport makes international travel particularly convenient.",
  ],
  nearbyCities: [
    { name: "Shakopee", zips: "55379" },
    { name: "Prior Lake", zips: "55372" },
    { name: "Chaska", zips: "55318" },
    { name: "Eden Prairie", zips: "55344, 55346, 55347" },
    { name: "Chanhassen", zips: "55317, 55331" },
    { name: "Savage", zips: "55378" },
  ],
  benefits: [
    {
      icon: "ri-computer-line",
      title: "Start 100% Online",
      desc: "No office visit required to begin. Complete your order from your home or office in minutes.",
    },
    {
      icon: "ri-truck-line",
      title: "Ship Your Documents",
      desc: "Use overnight shipping from Shakopee to send your documents directly to us.",
    },
    {
      icon: "ri-shield-check-line",
      title: "Expert Document Review",
      desc: "Every application is reviewed by our team before submission to reduce errors and prevent delays.",
    },
    {
      icon: "ri-calendar-check-line",
      title: "Reserved Agency Access",
      desc: "We hold reserved submission slots at the regional passport agency — no public appointment needed.",
    },
  ],
  serviceAreaTitle: "Shakopee & Southwest Metro Coverage",
  serviceAreaDescription: "Serving Scott County and southwest metro communities with overnight courier",
  faqs: [
    {
      q: "How fast can I get a passport in Shakopee, MN?",
      a: "Through Fast Passport Center, expedited processing can be as fast as 24 hours depending on your eligibility. Standard government processing through a post office in Shakopee can take 2–6 months. For families with Valleyfair and Canterbury Park travel plans, and professionals with business trips, that timeline is not viable.",
    },
    {
      q: "Can families get expedited passports before a vacation?",
      a: "Absolutely. Shakopee families are one of our most common client types. Many families book trips and discover passport issues close to departure. We regularly process expedited renewals and child passports for families on compressed timelines — as fast as 2–9 business days.",
    },
    {
      q: "What if my passport expires before a business trip?",
      a: "Shakopee professionals frequently travel for business with short notice. If your passport is expiring or expired, we can expedite your renewal so you do not miss critical meetings. Most business trips are scheduled 2–3 weeks out.",
    },
    {
      q: "Do I need to visit an office to use Fast Passport Center?",
      a: "No — most Shakopee travelers start online and ship their documents via overnight courier. There is no local Fast Passport Center office in Shakopee. Start your order online, follow the checklist, and ship your documents overnight from anywhere in the southwest metro.",
    },
    {
      q: "What documents do I need for an expedited passport?",
      a: "Most applicants need: proof of U.S. citizenship, a government-issued photo ID, completed passport forms, and passport photos. We provide a personalized checklist after you start your order, so you know exactly what is required.",
    },
    {
      q: "Is Fast Passport Center an official government agency?",
      a: "No — Fast Passport Center is a private, approved and registered U.S. Department of State passport courier service. We are not a government agency. We work within the official passport system to provide expedited processing.",
    },
  ],
  testimonials: [
    {
      name: "Jennifer K.",
      location: "Shakopee, MN",
      rating: 5,
      text: "We planned a family trip to Mexico and discovered my husband's passport had expired two weeks before departure. Fast Passport Center processed his renewal in four business days. We made our trip and had an incredible time. Thank you for the professional service.",
      service: "Passport Renewal",
    },
    {
      name: "Mark T.",
      location: "Shakopee, MN",
      rating: 5,
      text: "I received a last-minute assignment to a conference in London with ten days notice. My passport was within three months of expiration. Fast Passport Center processed my renewal in four business days. I made the conference and it was a great success. Exceptional service.",
      service: "Emergency Renewal",
    },
    {
      name: "The Nguyen Family",
      location: "Prior Lake / Shakopee Area",
      rating: 5,
      text: "We planned a family trip to Vietnam to visit relatives and discovered our daughter's passport had expired. Fast Passport Center processed her child passport in five business days. We made our trip and reconnected with family we had not seen in years. Thank you.",
      service: "Child Passport",
    },
  ],
  nearbyLinks: [
    { name: "Eden Prairie", href: "/eden-prairie" },
    { name: "Prior Lake", href: "/minnesota" },
    { name: "Chaska", href: "/minnesota" },
    { name: "Chanhassen", href: "/minnesota" },
    { name: "Minneapolis", href: "/minneapolis" },
    { name: "Burnsville", href: "/burnsville" },
  ],
  introTitle: "Emergency & Expedited Passport Services in Shakopee",
  introDescription: "Fast, reliable passport processing for Shakopee and southwest metro Scott County travelers.",
  localResourcesIntro:
    "Getting your passport ready involves more than just the application. Here are local Shakopee and southwest metro resources to help you gather everything you need before your next international trip.",
  acceptanceFacilities: [
    {
      name: "Shakopee Post Office",
      address: "105 5th Ave E, Shakopee, MN 55379",
      hours: "Mon–Fri 9:00 AM – 4:00 PM (appointment required)",
      phone: "(952) 445-5511",
      notes: "Passport acceptance services available by appointment. Photo services on-site. Primary facility for Shakopee and Scott County.",
    },
    {
      name: "Prior Lake Post Office",
      address: "4515 Dakota St SE, Prior Lake, MN 55372",
      hours: "Mon–Fri 9:00 AM – 4:00 PM",
      phone: "(952) 447-7321",
      notes: "Convenient for Prior Lake and Scott County residents. Passport photos available. Call ahead for appointment.",
    },
    {
      name: "Chaska Post Office",
      address: "100 E 2nd St, Chaska, MN 55318",
      hours: "Mon–Fri 9:00 AM – 4:00 PM",
      phone: "(952) 448-2321",
      notes: "Serves Chaska and Carver County residents. Call ahead for appointment availability.",
    },
    {
      name: "Eden Prairie Post Office",
      address: "12200 W 78th St, Eden Prairie, MN 55344",
      hours: "Mon–Fri 9:00 AM – 4:00 PM",
      phone: "(952) 937-1271",
      notes: "Serves Eden Prairie and Hennepin County residents near the southwest metro.",
    },
  ],
  photoLocations: [
    { name: "CVS Pharmacy — Shakopee", address: "1350 1st Ave E, Shakopee, MN 55379", hours: "Daily 7 AM – 10 PM" },
    { name: "Walgreens — Shakopee", address: "1660 Vierling Dr, Shakopee, MN 55379", hours: "Call for hours" },
    { name: "The UPS Store — Shakopee", address: "8090 Old Carriage Ct, Shakopee, MN 55379", hours: "Call for hours" },
    { name: "Walgreens — Prior Lake", address: "5740 Prettier Dr, Prior Lake, MN 55372", hours: "Call for hours" },
    { name: "CVS Pharmacy — Chaska", address: "800 Yellow Brick Rd, Chaska, MN 55318", hours: "Daily 7 AM – 10 PM" },
    { name: "FedEx Office — Eden Prairie", address: "13000 Technology Dr, Eden Prairie, MN 55344", hours: "Call for hours" },
  ],
  dmvLocations: [
    {
      name: "Minnesota Driver and Vehicle Services — Shakopee",
      address: "Shakopee area offices",
      hours: "Mon–Fri, 8:00 AM – 5:00 PM",
      note: "Driver licenses, REAL ID, titles & registration. Appointment recommended.",
      featured: true,
    },
    {
      name: "Scott County Service Center",
      address: "Shakopee, MN 55379",
      hours: "Mon–Fri, 8:00 AM – 4:30 PM",
      note: "Scott County services. Online scheduling available.",
      featured: false,
    },
  ],
  airports: [
    {
      code: "MSP",
      name: "Minneapolis-Saint Paul International Airport",
      distance: "About 25 miles from Shakopee — 30 minutes by car",
      address: "4300 Glumack Drive, St. Paul, MN 55111",
      note: "Primary commercial airport for Shakopee residents. Direct international flights to Europe, Asia, and Latin America. The southwest metro location provides excellent access via Highway 169 or 494.",
      flightUrl: "https://www.mspairport.com/",
      flightLabel: "MSP Airport Website",
      featured: true,
    },
    {
      code: "RST",
      name: "Rochester International Airport",
      distance: "Rochester, MN — about 95 miles south",
      address: "7600 Helgerson Dr SW, Rochester, MN 55902",
      note: "Secondary option for southern Minnesota travelers. Seasonal international charters and domestic connections.",
      flightUrl: "https://www.flyrst.com/",
      flightLabel: "Rochester Airport",
      featured: false,
    },
  ],
  travelCards: [
    {
      title: "MSP Airport Proximity",
      subtitle: "Only 30 minutes from Shakopee — excellent access for international travel",
      content:
        "Shakopee's location in the southwest metro provides excellent access to MSP Airport via Highway 169 or I-494. This proximity is a major advantage for the area's frequent international travelers. With nonstop service to Amsterdam, London, Paris, Tokyo, and Reykjavik, many residents connect directly to Europe and Asia.",
      tip: "Check your passport expiration before booking MSP international connections. Most countries require six months validity beyond your return date.",
      icon: "ri-flight-takeoff-line",
    },
    {
      title: "Southwest Metro Family Travel",
      subtitle: "Active families with travel plans throughout the year",
      content:
        "Shakopee families are among the most active travelers in the southwest metro. Spring break trips, summer vacations, and holiday visits to relatives abroad are all common. The area's proximity to MSP makes international travel particularly convenient for families.",
      tip: "Check every family member's passport at the start of the school year. Children's passports expire in 5 years, not 10. Plan renewals 6 months before any planned travel.",
      icon: "ri-parent-line",
    },
    {
      title: "Canterbury Park & Valleyfair Events",
      subtitle: "Entertainment and travel events drawing visitors from across the region",
      content:
        "Shakopee is home to Canterbury Park and Valleyfair, two major attractions that draw visitors from across the Upper Midwest. These events create travel opportunities for families, groups, and individuals who may extend their trips into international vacations.",
      tip: "Event and vacation travel often overlaps. If you are planning a trip around a Shakopee event, check your passport early to avoid last-minute issues.",
      icon: "ri-ticket-line",
    },
    {
      title: "Southwest Metro Business Travel",
      subtitle: "Professionals with international clients and partnerships",
      content:
        "Shakopee's growing business community includes technology, manufacturing, and healthcare companies with international clients. These professionals often travel for business development, client meetings, and trade shows. Business travel frequently has 2–3 weeks notice.",
      tip: "Southwest metro professionals should check passport expiration quarterly. Set calendar reminders. Business travel often has unpredictable lead times.",
      icon: "ri-briefcase-4-line",
    },
  ],
  destinations: [
    {
      name: "Mexico",
      context: "Cancun, Puerto Vallarta, and Cabo for spring break and family vacations",
      urgency: "Spring break trips and resort packages are often booked 2–4 weeks out",
      icon: "ri-map-pin-2-line",
    },
    {
      name: "Caribbean",
      context: "Cruises, all-inclusive resorts, and island hopping",
      urgency: "Cruise departures and resort packages are often booked 3–6 weeks out",
      icon: "ri-map-pin-2-line",
    },
    {
      name: "United Kingdom",
      context: "London business meetings and conferences",
      urgency: "Business and conference schedules are fixed and non-negotiable",
      icon: "ri-map-pin-2-line",
    },
    {
      name: "Germany",
      context: "Frankfurt, Munich, and Berlin for business and conferences",
      urgency: "Conference and event schedules are fixed and non-negotiable",
      icon: "ri-map-pin-2-line",
    },
    {
      name: "Vietnam",
      context: "Family visits and heritage travel for the area's Vietnamese community",
      urgency: "Family visits are often planned 2–4 weeks out due to changing schedules",
      icon: "ri-map-pin-2-line",
    },
    {
      name: "Canada",
      context: "Toronto, Vancouver, and weekend getaways",
      urgency: "Summer travel and weekend trips peak May through September",
      icon: "ri-map-pin-2-line",
    },
  ],
  stats: [
    {
      stat: "45%",
      label: "of Shakopee expedited requests are family travel discovered within 3 weeks of departure",
    },
    {
      stat: "2–4 Weeks",
      label: "average notice Shakopee travelers have before a planned international trip",
    },
    {
      stat: "Mar–Aug",
      label: "peak season when spring break, summer vacations, and event travel coincide",
    },
    {
      stat: "48 Hours",
      label: "shortest emergency turnaround we have accommodated for a Shakopee professional",
    },
  ],
};

export default function ShakopeePage() {
  return <CityPage data={data} />;
}